import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress-lb col-md-12",
  style: {"padding-left":"0px !important","padding-right":"0px !important"}
}
const _hoisted_2 = {
  key: 1,
  class: "progress",
  style: {"width":"100%"}
}


export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    max: { default: 100 },
    variant: { default: "default" },
    color: { default: "bg-success" }
  },
  setup(__props: any) {

/**
 * ProgressBar — dois variantes:
 *   - "default": barra Bootstrap padrão (progress / progress-value)
 *   - "xp":      barra customizada do tema HC (progress-lb / progress-value-lb)
 *
 * Uso:
 *   <ProgressBar :value="75" />
 *   <ProgressBar :value="350" :max="1000" variant="xp" color="bg-success" />
 */


return (_ctx: any,_cache: any) => {
  return (__props.variant === 'xp')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["progress-value-lb", __props.color]),
          style: _normalizeStyle([{"margin-left":"-3px"}, { width: `${(__props.value / __props.max) * 100}%` }])
        }, null, 6)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "progress-value",
          style: _normalizeStyle({ width: `${(__props.value / __props.max) * 100}%` })
        }, null, 4)
      ]))
}
}

})